var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 48 48"}},[_c('path',{attrs:{"fill":"none","stroke":"#ea5455","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"4","d":"M43 12H3v30h40V12ZM11 6H3v6h8V6Zm32 0h-8v6h8V6ZM9 21h6m16 0h6m-25-3v6"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }